__turbopack_context__.v({
  "dataContent": "Innerhtml-module__8z-wNG__dataContent",
  "editorArea": "Innerhtml-module__8z-wNG__editorArea",
  "tableWrapper": "Innerhtml-module__8z-wNG__tableWrapper",
});
